import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './App'
import { AuthProvider } from './context/AuthContext'
import { SettingsProvider } from './context/SettingsContext'
import { ToastProvider } from './context/ToastContext'
import { ModelsProvider } from './context/ModelsContext'
import { VideoTemplatesProvider } from './context/VideoTemplatesContext'
import { WorksProvider } from './context/WorksContext'
import { AssetLibraryProvider } from './context/AssetLibraryContext'
import { JobCenterProvider } from './context/JobCenterContext'
import './styles/tokens.css'
import './styles/global.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Provider 顺序有依赖：Auth → Settings → Toast → Models → Works → Assets → JobCenter
        **Auth 必须在最外层**：它是「当前是谁」，下面每一个上下文拉的都是**这个账号的**
        数据（任务 / 作品 / 素材 / 用量）。放到里面的话，切账号时其它上下文不会重拉，
        新账号会看到上一个账号的数据。 */}
    <AuthProvider>
      <SettingsProvider>
        <ToastProvider>
          <ModelsProvider>
            {/* 自存视频模板：挂在 Auth 之内（按账号收口，换账号要重拉），
                与 Works / Assets 并列 —— 它不依赖任务队列，也不被队列依赖。
                Provider 顺序仍守那条规矩：Auth 永远最外层。 */}
            <VideoTemplatesProvider>
              <WorksProvider>
                <AssetLibraryProvider>
                  <JobCenterProvider>
                    <BrowserRouter>
                      <App />
                    </BrowserRouter>
                  </JobCenterProvider>
                </AssetLibraryProvider>
              </WorksProvider>
            </VideoTemplatesProvider>
          </ModelsProvider>
        </ToastProvider>
      </SettingsProvider>
    </AuthProvider>
  </StrictMode>,
)
